import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function LuxPageHero({ label, title, highlight, description, cta }) {
  return (
    <section className="lux-inner-hero">
      <div className="lux-inner-hero__mesh" aria-hidden="true" />
      <div className="lux-inner-hero__inner">
        <motion.span
          className="cine-hero__label"
          style={{ color: 'var(--accent)' }}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {label}
        </motion.span>
        <motion.h1
          className="lux-inner-hero__title"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, delay: 0.1 }}
        >
          {title}
          {highlight && (
            <>
              <br />
              <em>{highlight}</em>
            </>
          )}
        </motion.h1>
        {description && (
          <motion.p
            className="lux-inner-hero__desc"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.25 }}
          >
            {description}
          </motion.p>
        )}
        {cta && (
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
            <Link to={cta.to} className="btn-lux btn-lux--fill" style={{ color: '#030712' }}>
              {cta.label}
            </Link>
          </motion.div>
        )}
      </div>
    </section>
  );
}
